<button
  #filterItem
  nimbusPrimaryNoBorderButton
  [disabled]="option.disabled"
  class="filter-item"
  (click)="onClick($event)"
  [ngClass]="{ 'filter-item-locked': option.disabled }"
  [style.padding-left.px]="option.level * indent + 7"
>
  <nimbus-input-check-box [checked]="selected"></nimbus-input-check-box>
  <div class="flex-container icon-container">
    @if (option.icon) {
      <i [nimbusIcon]="option.icon"></i>
    }
    @if (option.color) {
      <span class="filter-color-indicator" [style.background]="option.color"></span>
    }
  </div>
  <span class="filter-item-name">{{ option.name }} <nimbus-tooltip [text]="option.name"> </nimbus-tooltip></span>
</button>
